export const TIMER_STATUS = ["STOPPED", "STARTED"];